import { languageService } from "../../Language/language.service";
import { lang } from "moment";
export const compNames = {
  mainHeadingName: "Inspection Run Planning",
  subHeadingSummaryName: "Summary",
  subHeadingTableName: "Inspection Run Plans",
  addButtonToolTipName: "Inspection Plan",
  addButtonHeadingName: "Add Plan"
};

export const compDetailNames = {
  mainHeadingName: "Inspection Run Plan Detail",
  subHeadingSummaryName: "Inspection Run Plan Detail",
  subHeadingTableName: "Task List",
  addButtonToolTipName: "Task",
  addButtonHeadingName: "Task"
};



// WEBPACK FOOTER //
// ./src/components/WorkPlanTemplate/componentNames.js